import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[nlrUppercase]',
    standalone: true
})
export class NlrUppercaseDirective {
    constructor() {}

    @HostListener('input', ['$event']) onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart;
        const end = input.selectionEnd;

        const upper = input.value.toUpperCase();
        if (input.value !== upper) {
            input.value = upper;
            // This is to keep cursor on the same position if editing
            input.setSelectionRange(start, end);
            // Dispatch input event so Angular updates the model
            // Fixes an issue where the last character in the model was incorrectly kept in lowercase, e.g., 'ROAd'
            const newEvent = new Event('input');
            input.dispatchEvent(newEvent);
        }
    }
}
